const types = {
  CONSIGNMENT_STOCK_DELTA_PN: 'CONSIGNMENT_STOCK_DELTA_PN',
  CONSIGNMENT_SUMMARY_STOCK_DELTA_PN: 'CONSIGNMENT_SUMMARY_STOCK_DELTA_PN',
  WEEKLY_GI_DETAIL_FOR_THAILAND_PN: 'WEEKLY_GI_DETAIL_FOR_THAILAND_PN',
  WEEKLY_GI_DETAIL_FOR_THAILAND_WEEK_NO: 'WEEKLY_GI_DETAIL_FOR_THAILAND_WEEK_NO'
}

const state = {
  consignmentStockDeltaPn: '',
  consignmentSummaryStockDeltaPn: '',
  weeklyGiDetailForThailandPn: '',
  weeklyGiDetailForThailandWeekNo: ''
}

const getters = {
  getConsignmentStockDeltaPn: state => state.consignmentStockDeltaPn, 
  getConsignmentSummaryStockDeltaPn: state => state.consignmentSummaryStockDeltaPn,
  getWeeklyGiDetailForThailandPn: state => state.weeklyGiDetailForThailandPn,
  getWeeklyGiDetailForThailandWeekNo: state => state.weeklyGiDetailForThailandWeekNo
}


const actions = {
  setConsignmentStockDeltaPn({ commit }, consignmentStockDeltaPn) {
    commit(types.CONSIGNMENT_STOCK_DELTA_PN, consignmentStockDeltaPn)
  },
  setConsignmentSummaryStockDeltaPn({ commit }, consignmentSummaryStockDeltaPn) {
    commit(types.CONSIGNMENT_SUMMARY_STOCK_DELTA_PN, consignmentSummaryStockDeltaPn)
  },
  setWeeklyGiDetailForThailandPn({ commit }, weeklyGiDetailForThailandPn) {
    commit(types.WEEKLY_GI_DETAIL_FOR_THAILAND_PN, weeklyGiDetailForThailandPn)
  },
  setWeeklyGiDetailForThailandWeekNo({ commit }, weeklyGiDetailForThailandWeekNo) {
    commit(types.WEEKLY_GI_DETAIL_FOR_THAILAND_WEEK_NO, weeklyGiDetailForThailandWeekNo)
  },
}

const mutations = {
  [types.CONSIGNMENT_STOCK_DELTA_PN](state, consignmentStockDeltaPn) {
    state.consignmentStockDeltaPn = consignmentStockDeltaPn
  },
  [types.CONSIGNMENT_SUMMARY_STOCK_DELTA_PN](state, consignmentSummaryStockDeltaPn) {
    state.consignmentSummaryStockDeltaPn = consignmentSummaryStockDeltaPn
  },
  [types.WEEKLY_GI_DETAIL_FOR_THAILAND_PN](state, weeklyGiDetailForThailandPn) {
    state.weeklyGiDetailForThailandPn = weeklyGiDetailForThailandPn
  },
  
  [types.WEEKLY_GI_DETAIL_FOR_THAILAND_WEEK_NO](state, weeklyGiDetailForThailandWeekNo) {
    state.weeklyGiDetailForThailandWeekNo = weeklyGiDetailForThailandWeekNo
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}